var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BAlert',{staticClass:"position-fixed fixed-bottom m-0 rounded-0",staticStyle:{"z-index":"2000"},attrs:{"show":_vm.isRefresh,"variant":"info","dismissible":""}},[_vm._v(" A new version is available."),_c('button',{staticClass:"ml-2 btn btn-primary",on:{"click":_vm.update}},[_vm._v(" Update ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }